import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02b6b4a7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-permission-container"
};
const _hoisted_2 = {
  class: "user-list-panel"
};
const _hoisted_3 = {
  class: "search-box"
};
const _hoisted_4 = {
  class: "search-box-item"
};
const _hoisted_5 = {
  class: "user-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "user-name"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  key: 0,
  class: "loading-more"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在加载更多...", -1));
const _hoisted_11 = {
  key: 1,
  class: "empty-list"
};
const _hoisted_12 = {
  key: 2,
  class: "list-end-tip"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已加载全部数据", -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "permission-panel"
};
const _hoisted_16 = {
  class: "panel-header"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "用户权限", -1));
const _hoisted_18 = {
  class: "header-right"
};
const _hoisted_19 = {
  class: "user-title"
};
const _hoisted_20 = {
  key: 0,
  class: "permission-content"
};
const _hoisted_21 = {
  class: "group-title"
};
const _hoisted_22 = {
  class: "permission-items"
};
const _hoisted_23 = {
  key: 1,
  class: "empty-placeholder"
};
const _hoisted_24 = {
  key: 0,
  class: "product-permission-content"
};
const _hoisted_25 = {
  class: "product-search-box"
};
const _hoisted_26 = {
  class: "product-list"
};
const _hoisted_27 = {
  class: "product-table-header"
};
const _hoisted_28 = {
  class: "batch-actions"
};
const _hoisted_29 = {
  key: 1,
  class: "empty-placeholder"
};
import { ref, reactive, onMounted, watch } from 'vue';
import { message } from 'ant-design-vue';
import { UserOutlined } from '@ant-design/icons-vue';
import { queryAllUsers, editUserPerms, getRoleList, queryAllApps, saveDbtByUserId } from '@/api/permission';
import { useUser } from '@/views/permissionManage/useUser';
import { getResourceList } from '@/api/menuMangeApi';
import PermissionTree from '@/components/PermissionTree.vue';
// 编辑模式状态
export default /*#__PURE__*/_defineComponent({
  __name: 'userPermission',
  setup(__props) {
    const isEditMode = ref(false);
    // 标签页相关
    const activeTab = ref('function');
    // 用户列表相关
    const userList = ref([]);
    const currentUser = ref(null);
    const searchKeyword = ref('');
    const selectedRoleId = ref(null);
    const roleOptions = ref([]);
    const loading = ref(false);
    const loadingMore = ref(false);
    const hasMoreUsers = ref(true);
    const loadingTrigger = ref(null);
    // 权限相关
    const permissionGroups = ref([]);
    const selectedPermissions = reactive({});
    const {
      allPerList,
      allApps
    } = useUser();
    const resourceList = ref([]);
    // 分页相关
    const pageIndex = ref(1);
    const pageSize = ref(100);
    const pageTotal = ref(0);
    // 产品权限相关
    const productSearchKeyword = ref('');
    const productList = ref([]);
    const filteredProductList = ref([]);
    const productLoading = ref(false);
    const productPageIndex = ref(1);
    const productPageSize = ref(20);
    const productTotal = ref(0);
    const selectedProductKeys = ref([]);
    const userProductPermissions = ref([]);
    // 产品权限表格列定义
    const productColumns = [{
      title: '产品名称',
      dataIndex: 'dbtName',
      key: 'dbtName'
    }, {
      title: 'dbtid',
      dataIndex: 'dbtid',
      key: 'dbtid'
    }, {
      title: '授权',
      dataIndex: 'status',
      key: 'status',
      align: 'right'
    }];
    // 添加savingLoading状态变量
    const savingLoading = ref(false);
    // 获取角色列表
    const fetchRoleOptions = async () => {
      try {
        const {
          code,
          pageRoleInfo
        } = await getRoleList({
          currentPage: 1,
          pageSize: 2000
        });
        if (code === '0000') {
          roleOptions.value = pageRoleInfo.map(item => ({
            label: item.roleName,
            value: item.roleCode
          }));
        }
      } catch (error) {
        console.error('获取角色列表失败', error);
      }
    };
    // 获取用户列表
    const fetchUserList = async (isLoadMore = false) => {
      try {
        const params = {
          currentPage: pageIndex.value,
          pageSize: pageSize.value,
          condition: searchKeyword.value,
          roleCodes: selectedRoleId.value
        };
        const {
          code,
          userCount,
          pageUserInfo
        } = await queryAllUsers(params);
        if (code === '0000') {
          if (isLoadMore) {
            // 追加新数据
            userList.value = [...userList.value, ...pageUserInfo];
          } else {
            // 替换数据
            userList.value = pageUserInfo;
          }
          pageTotal.value = userCount;
          // 判断是否还有更多数据
          hasMoreUsers.value = userList.value.length < userCount;
          // 如果有用户且当前未选择用户，则自动选择第一个（仅在初次加载时）
          if (userList.value.length > 0 && !currentUser.value && !isLoadMore) {
            selectUser(userList.value[0]);
          }
        }
      } catch (error) {
        console.error('获取用户列表失败', error);
      } finally {
        loading.value = false;
        loadingMore.value = false;
      }
    };
    // 加载更多用户
    const loadMoreUsers = async () => {
      if (loadingMore.value || !hasMoreUsers.value) return;
      loadingMore.value = true;
      pageIndex.value += 1;
      await fetchUserList(true);
    };
    // 搜索用户
    const handleSearch = () => {
      pageIndex.value = 1;
      currentUser.value = null;
      loading.value = true;
      hasMoreUsers.value = true;
      fetchUserList();
    };
    // 选择用户
    const selectUser = user => {
      currentUser.value = user;
      initPermissions();
      if (activeTab.value === 'product') {
        fetchProductList();
      }
    };
    // 获取权限资源列表
    const fetchResourceList = async () => {
      try {
        const {
          code,
          data
        } = await getResourceList();
        if (code === '0' && data) {
          resourceList.value = data;
          initPermissionGroups();
        }
      } catch (error) {
        console.error('获取权限资源列表失败', error);
      }
    };
    // 初始化权限数据
    const initPermissions = () => {
      // 清空已选权限
      Object.keys(selectedPermissions).forEach(key => {
        selectedPermissions[key] = false;
      });
      // 设置当前用户已有的权限
      if (currentUser.value && currentUser.value.permId) {
        const permIds = currentUser.value.permId.split(',');
        permIds.forEach(id => {
          selectedPermissions[id] = true;
        });
      }
    };
    // 初始化权限分组
    const initPermissionGroups = () => {
      if (!resourceList.value || resourceList.value.length === 0) return;
      // 直接使用API返回的树形结构
      permissionGroups.value = resourceList.value.map(item => ({
        key: item.id,
        title: item.name,
        permissionId: item.permissionId,
        permission: item.permission,
        items: item.children || []
      }));
      permissionGroups.value = permissionGroups.value.filter(item => {
        var _item$items;
        return (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length;
      }).map(item => {
        return {
          ...item,
          items: item.items.map(e => {
            return {
              ...e,
              children: e.children.length > 0 ? e.children : e.resType === 2 ? [{
                ...e
              }] : []
            };
          })
        };
      });
      // 递归初始化所有权限的选中状态
      const initAllPermissions = resources => {
        if (!resources || resources.length === 0) return;
        resources.forEach(resource => {
          // 使用permissionId作为唯一标识符
          selectedPermissions[resource.permissionId] = false;
          // 递归处理子权限
          if (resource.children && resource.children.length > 0) {
            initAllPermissions(resource.children);
          }
        });
      };
      // 初始化所有权限的选中状态
      initAllPermissions(resourceList.value);
    };
    // 检查组是否部分选中
    const isIndeterminate = groupKey => {
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return false;
      // 获取组内所有权限ID（包括子权限）
      const allPermIds = getAllPermissionIds(group.items);
      if (allPermIds.length === 0) return false;
      const checkedCount = allPermIds.filter(id => selectedPermissions[id]).length;
      return checkedCount > 0 && checkedCount < allPermIds.length;
    };
    // 检查组是否全选
    const isGroupChecked = groupKey => {
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return false;
      // 获取组内所有权限ID（包括子权限）
      const allPermIds = getAllPermissionIds(group.items);
      if (allPermIds.length === 0) return false;
      return allPermIds.every(id => selectedPermissions[id]);
    };
    // 递归获取所有权限ID
    const getAllPermissionIds = resources => {
      if (!resources || resources.length === 0) return [];
      let result = [];
      resources.forEach(resource => {
        // 添加当前资源的权限ID
        result.push(resource.permissionId);
        // 递归添加子资源的权限ID
        if (resource.children && resource.children.length > 0) {
          result = result.concat(getAllPermissionIds(resource.children));
        }
      });
      return result;
    };
    // 组选择变化
    const onGroupCheckChange = (groupKey, e) => {
      const checked = e.target.checked;
      const group = permissionGroups.value.find(g => g.key === groupKey);
      if (!group) return;
      // 递归设置组内所有权限的选中状态
      setResourceChecked(group.items, checked);
      // 额外选中组本身的权限
      if (group.permissionId) {
        selectedPermissions[group.permissionId] = checked;
      }
    };
    // 递归设置资源的选中状态
    const setResourceChecked = (resources, checked) => {
      if (!resources || resources.length === 0) return;
      resources.forEach(resource => {
        // 设置当前资源的选中状态
        if (resource.permissionId) {
          selectedPermissions[resource.permissionId] = checked;
        }
        // 递归设置子资源的选中状态
        if (resource.children && resource.children.length > 0) {
          setResourceChecked(resource.children, checked);
        }
      });
    };
    // 权限选择变化
    const handlePermissionChange = data => {
      if (data && data.permissionId) {
        selectedPermissions[data.permissionId] = data.checked;
      }
    };
    // 处理级联权限变化事件（批量更新多个权限）
    const handleCascadePermissionChange = updateItems => {
      if (!updateItems || updateItems.length === 0) return;
      // 批量更新所有权限状态
      updateItems.forEach(item => {
        if (item && item.permissionId) {
          selectedPermissions[item.permissionId] = item.checked;
        }
      });
    };
    // 进入编辑模式
    const enterEditMode = () => {
      isEditMode.value = true;
    };
    // 取消编辑模式
    const cancelEdit = () => {
      isEditMode.value = false;
      // 重置权限状态
      if (activeTab.value === 'function') {
        initPermissions(); // 重置功能权限为原始状态
      } else if (activeTab.value === 'product') {
        fetchProductList(); // 重新获取产品权限列表
      }
    };
    // 保存权限
    const savePermissions = async () => {
      if (!currentUser.value) {
        message.warning('请先选择用户');
        return;
      }
      savingLoading.value = true; // 开始保存，显示loading
      try {
        if (activeTab.value === 'function') {
          // 收集已选功能权限ID
          const selectedPermIds = Object.keys(selectedPermissions).filter(id => selectedPermissions[id]);
          try {
            const {
              code
            } = await editUserPerms({
              uid: currentUser.value.id,
              pid: selectedPermIds.join(',')
            });
            if (code === '0000') {
              message.success('功能权限保存成功');
              // 刷新用户列表，获取最新权限信息
              fetchUserList();
              // 退出编辑模式
              isEditMode.value = false;
            }
          } catch (error) {
            console.error('保存功能权限失败', error);
            message.error('保存功能权限失败');
          }
        } else if (activeTab.value === 'product') {
          // 保存产品权限
          try {
            const {
              code
            } = await saveDbtByUserId({
              dbtids: userProductPermissions.value,
              userid: currentUser.value.id
            });
            if (code === '0') {
              message.success('产品权限保存成功');
              // 刷新产品列表
              fetchProductList();
              // 退出编辑模式
              isEditMode.value = false;
            }
          } catch (error) {
            console.error('保存产品权限失败', error);
            message.error('保存产品权限失败');
          }
        }
      } finally {
        savingLoading.value = false; // 保存完成，隐藏loading
      }
    };
    // 获取产品列表
    const fetchProductList = async () => {
      if (!currentUser.value) return;
      productLoading.value = true;
      try {
        // 获取用户有权限的应用列表
        const userAppsResponse = await queryAllApps({
          userId: currentUser.value.id
        });
        if (userAppsResponse.code === '0' && allApps.value && allApps.value.length > 0) {
          // 获取用户已有权限的应用ID列表
          const userAppIds = userAppsResponse.data.map(item => item.dbtid);
          userProductPermissions.value = userAppIds;
          // 合并数据，标记用户是否拥有权限
          productList.value = allApps.value.map(app => ({
            dbtid: app.id,
            dbtName: app.name,
            hasPermission: userAppIds.includes(app.id)
          }));
          // 初始应用本地过滤
          filterProductList();
        }
      } catch (error) {
        console.error('获取产品列表失败', error);
        message.error('获取产品列表失败');
      } finally {
        productLoading.value = false;
      }
    };
    // 本地过滤产品列表
    const filterProductList = () => {
      if (!productList.value) {
        filteredProductList.value = [];
        return;
      }
      const keyword = productSearchKeyword.value.toLowerCase().trim();
      if (keyword) {
        // 根据关键字过滤列表
        filteredProductList.value = productList.value.filter(item => item.dbtName && item.dbtName.toLowerCase().includes(keyword) || item.dbtid && item.dbtid.toLowerCase().includes(keyword));
      } else {
        // 不过滤
        filteredProductList.value = productList.value;
      }
      productTotal.value = filteredProductList.value.length;
      // 重置分页到第一页
      if (productPageIndex.value !== 1) {
        productPageIndex.value = 1;
      }
    };
    // 产品搜索
    const searchProduct = () => {
      filterProductList();
    };
    // 重置产品搜索
    const resetProductSearch = () => {
      productSearchKeyword.value = '';
      filterProductList();
    };
    // 切换产品权限
    const handleTogglePermission = async (record, checked) => {
      if (!isEditMode.value) return;
      // 更新本地数据状态，不发送请求
      record.hasPermission = checked;
      // 更新用户权限列表
      if (checked) {
        if (!userProductPermissions.value.includes(record.dbtid)) {
          userProductPermissions.value.push(record.dbtid);
        }
      } else {
        userProductPermissions.value = userProductPermissions.value.filter(id => id !== record.dbtid);
      }
    };
    // 批量授权/取消授权
    const handleBatchPermission = async type => {
      if (!currentUser.value) {
        message.warning('请先选择用户');
        return;
      }
      const selectedRowKeys = filteredProductList.value.filter(item => item.hasPermission || type === 1 && selectedProductKeys.value.includes(item.dbtid)).map(item => item.dbtid);
      if (selectedRowKeys.length === 0 && type === 1) {
        message.warning('请先选择产品');
        return;
      }
      // 更新本地数据状态
      if (type === 1) {
        // 批量授权选中行
        selectedProductKeys.value.forEach(dbtid => {
          const item = productList.value.find(p => p.dbtid === dbtid);
          if (item) {
            item.hasPermission = true;
            if (!userProductPermissions.value.includes(dbtid)) {
              userProductPermissions.value.push(dbtid);
            }
          }
        });
      } else {
        // 批量取消授权所有行
        productList.value.forEach(item => {
          item.hasPermission = false;
        });
        userProductPermissions.value = [];
        selectedProductKeys.value = [];
      }
    };
    // 产品表格选择变更
    const onSelectChange = selectedRowKeys => {
      selectedProductKeys.value = selectedRowKeys;
    };
    // 产品分页变更
    const changeProductPage = (page, pageSize) => {
      selectedProductKeys.value = [];
      productPageIndex.value = page;
      productPageSize.value = pageSize;
    };
    // 标签页切换处理
    const handleTabChange = newTab => {
      // 允许切换标签页
      if (newTab === 'product' && currentUser.value) {
        fetchProductList();
      }
    };
    // 角色选择器的过滤函数
    const filterRoleOption = (input, option) => {
      if (!input) return true;
      // 转换为小写以进行不区分大小写的搜索
      const searchText = input.toLowerCase();
      // 检查角色名称(label)是否包含搜索文本
      if (option.label && option.label.toLowerCase().includes(searchText)) {
        return true;
      }
      // 检查角色编码(value)是否包含搜索文本
      if (option.value && option.value.toLowerCase().includes(searchText)) {
        return true;
      }
      return false;
    };
    // 用于监听滚动到底部的Intersection Observer
    const setupScrollObserver = () => {
      if (!loadingTrigger.value) return;
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !loadingMore.value) {
          loadMoreUsers();
        }
      }, {
        threshold: 0.5
      });
      observer.observe(loadingTrigger.value);
      // 在组件卸载时清理观察者
      return () => {
        if (loadingTrigger.value) {
          observer.unobserve(loadingTrigger.value);
        }
        observer.disconnect();
      };
    };
    // 监听标签页切换
    watch(activeTab, (newVal, oldVal) => {
      if (newVal !== oldVal && currentUser.value) {
        if (newVal === 'product') {
          fetchProductList();
        }
      }
    });
    // 监听权限列表变化，初始化分组
    watch(() => allPerList.value, () => {
      // 不再使用 allPerList 来初始化权限分组
    }, {
      immediate: true
    });
    onMounted(async () => {
      // 获取角色选项
      await fetchRoleOptions();
      // 获取权限资源列表
      await fetchResourceList();
      // 获取用户列表
      loading.value = true;
      await fetchUserList();
      // 设置滚动观察器
      setupScrollObserver();
    });
    return (_ctx, _cache) => {
      var _currentUser$value2;
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_input, {
        placeholder: "输入账号名称",
        value: searchKeyword.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        onPressEnter: handleSearch
      }, null, 8, ["value"]), _createVNode(_component_a_select, {
        placeholder: "选择角色",
        value: selectedRoleId.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => selectedRoleId.value = $event),
        "allow-clear": "",
        options: roleOptions.value,
        "filter-option": filterRoleOption,
        "show-search": "",
        onChange: handleSearch
      }, null, 8, ["value", "options"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_spin, {
        spinning: loading.value,
        tip: "加载中..."
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, user => {
          var _currentUser$value;
          return _openBlock(), _createElementBlock("div", {
            key: user.id,
            class: _normalizeClass(["user-item", {
              active: ((_currentUser$value = currentUser.value) === null || _currentUser$value === void 0 ? void 0 : _currentUser$value.id) === user.id
            }]),
            onClick: $event => selectUser(user)
          }, [_createVNode(_unref(UserOutlined)), _createElementVNode("span", _hoisted_7, _toDisplayString(user.username), 1), _createElementVNode("span", {
            class: "user-role",
            title: user.roleNames
          }, _toDisplayString(user.roleNames), 9, _hoisted_8)], 10, _hoisted_6);
        }), 128)), hasMoreUsers.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "loadingTrigger",
          ref: loadingTrigger,
          class: "loading-trigger"
        }, [loadingMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_spin, {
          size: "small"
        }), _hoisted_10])) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true), userList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_a_empty, {
          description: "无符合条件的用户"
        })])) : _createCommentVNode("", true), !hasMoreUsers.value && userList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["spinning"])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(((_currentUser$value2 = currentUser.value) === null || _currentUser$value2 === void 0 ? void 0 : _currentUser$value2.name) || ''), 1), isEditMode.value ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: cancelEdit
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      })) : _createCommentVNode("", true), isEditMode.value ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        type: "primary",
        onClick: savePermissions,
        loading: savingLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])) : _createCommentVNode("", true), !isEditMode.value ? (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        type: "primary",
        onClick: enterEditMode
      }, {
        default: _withCtx(() => [_createTextVNode("编辑")]),
        _: 1
      })) : _createCommentVNode("", true)])]), _createVNode(_component_a_tabs, {
        activeKey: activeTab.value,
        "onUpdate:activeKey": _cache[7] || (_cache[7] = $event => activeTab.value = $event),
        class: "permission-tabs",
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "function",
          tab: "功能权限"
        }, {
          default: _withCtx(() => [currentUser.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionGroups.value, group => {
            return _openBlock(), _createElementBlock("div", {
              class: "permission-group",
              key: group.key
            }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_a_checkbox, {
              indeterminate: isIndeterminate(group.key),
              checked: isGroupChecked(group.key),
              disabled: !isEditMode.value,
              onChange: $event => onGroupCheckChange(group.key, $event)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(group.title), 1)]),
              _: 2
            }, 1032, ["indeterminate", "checked", "disabled", "onChange"])]), _createElementVNode("div", _hoisted_22, [_createVNode(PermissionTree, {
              resources: group.items,
              "selected-permissions": selectedPermissions,
              "is-edit-mode": isEditMode.value,
              onChange: handlePermissionChange,
              onCascadeChange: handleCascadePermissionChange,
              class: "first-level"
            }, null, 8, ["resources", "selected-permissions", "is-edit-mode"])])]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_23, "请先选择左侧用户"))]),
          _: 1
        }), _createVNode(_component_a_tab_pane, {
          key: "product",
          tab: "产品权限"
        }, {
          default: _withCtx(() => [currentUser.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_a_input, {
            placeholder: "请输入产品名称/dbId",
            value: productSearchKeyword.value,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => productSearchKeyword.value = $event),
            onPressEnter: searchProduct
          }, null, 8, ["value"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: searchProduct
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }), _createVNode(_component_a_button, {
            onClick: resetProductSearch
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_a_button, {
            class: "batch-btn",
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => handleBatchPermission(1)),
            disabled: !isEditMode.value
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量授权(" + _toDisplayString(selectedProductKeys.value.length) + ") ", 1)]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_a_button, {
            class: "batch-btn",
            onClick: _cache[4] || (_cache[4] = $event => handleBatchPermission(0)),
            disabled: !isEditMode.value
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量取消授权(" + _toDisplayString(selectedProductKeys.value.length) + ") ", 1)]),
            _: 1
          }, 8, ["disabled"])])]), _createVNode(_component_a_table, {
            columns: productColumns,
            "data-source": filteredProductList.value.slice((productPageIndex.value - 1) * productPageSize.value, productPageIndex.value * productPageSize.value),
            "row-key": "dbtid",
            pagination: false,
            loading: productLoading.value,
            "row-selection": {
              selectedRowKeys: selectedProductKeys.value,
              onChange: onSelectChange,
              disabled: !isEditMode.value,
              type: 'checkbox'
            }
          }, {
            bodyCell: _withCtx(({
              column,
              record
            }) => [column.dataIndex === 'status' ? (_openBlock(), _createBlock(_component_a_switch, {
              key: 0,
              checked: record.hasPermission,
              onChange: checked => handleTogglePermission(record, checked),
              disabled: !isEditMode.value
            }, null, 8, ["checked", "onChange", "disabled"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data-source", "loading", "row-selection"]), _createVNode(_component_a_pagination, {
            class: "product-pagination",
            current: productPageIndex.value,
            "onUpdate:current": _cache[5] || (_cache[5] = $event => productPageIndex.value = $event),
            pageSize: productPageSize.value,
            "onUpdate:pageSize": _cache[6] || (_cache[6] = $event => productPageSize.value = $event),
            total: productTotal.value,
            "show-size-changer": "",
            onChange: changeProductPage
          }, null, 8, ["current", "pageSize", "total"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_29, "请先选择左侧用户"))]),
          _: 1
        })]),
        _: 1
      }, 8, ["activeKey"])])]);
    };
  }
});